export const ModalStates = {
  INITIAL: "INITIAL",
  GENERATING: "GENERATING",
  FINISHED: "FINISHED",
  ERROR: "ERROR",
};
